export const initialPosts = [
  {
    id: 1,
    title: 'How Are Mountains Formed?',
    body: `The world's tallest mountain ranges form when pieces of Earth's crust—called plates—smash against each other in a process called plate tectonics, and buckle up like the hood of a car in a head-on collision. The Himalaya in Asia formed from one such massive wreck that started about 55 million years ago. Thirty of the world’s highest mountains are in the Himalaya. The summit of Mount Everest, at 29,035 feet (8,850 meters), is the highest point on Earth.
    The tallest mountain measured from top to bottom is Mauna Kea, an inactive volcano on the island of Hawaii in the Pacific Ocean. Measured from the base, Mauna Kea stands 33,474 feet (10,203 meters) tall, though it only rises 13,796 feet (4,205 meters) above the sea.`
  },
  {
    id: 2,
    title: 'Impact of Mountains on Habitats and Geopolitics',
    body: 'Mountains often serve as geographic features that define natural borders of countries. Their height can influence weather patterns, stalling storms that roll off the oceans and squeezing water from the clouds. The other side is often much drier. The rugged landscapes even provide refuge—and protection—for fleeing and invading armies.'
  },
  {
    id: 3,
    title: 'Good thought',
    body: 'If you are faced with a mountain, you have several options. You can climb it and cross to the other side. You can go around it. You can dig under it. You can fly over it. You can blow it up. You can ignore it and pretend it’s not there. You can turn around and go back the way you came. Or you can stay on the mountain and make it your home.'
  },
  {
    id: 4,
    title: 'Inspirational quote',
    body: 'It’s not the mountain we conquer, but ourselves.'
  }
];

export const dropdownMenuItems = [
  {
    id: 1,
    option: 'Title'
  },
  {
    id: 2,
    option: 'Body'
  }
]
